<template>
  <div>
    <!-- <div class="edit_form">
      <edit-form
        ref="editForm"
        style="margin-left:5px"
        :formDisabled="formDisabled"
        :imageDisabled="imageDisabled"
        :isChangeName="isChangeName"
        :form="formData"
        @reload="reload"
      />
    </div>
    <div class="edit_form mt_10" v-if="skuDisabled">
      <SkuTable
        class="mt-1"
        v-if="skuDisabled"
        ref="skuTable"
        :amzSpuCode="amzSpuCode"
        :addSku="addSku"
        :form="formData"
      />
    </div> -->

    <el-card
      shadow="always"
      style="box-shadow:none;"
    >
      <EditForm
        ref="editForm"
        :formDisabled="formDisabled"
        :isChangeName="isChangeName"
        :form="formData"
        @reload="reload"
      />
    </el-card>
    <el-card
      shadow="always"
      style="box-shadow:none"
      v-if="skuDisabled"
      class="mt-2"
    >
      <SkuTable
        class="mt-1"
        v-if="skuDisabled"
        ref="skuTable"
        :amzSpuCode="amzSpuCode"
        :addSku="addSku"
        :form="formData"
      />
    </el-card>
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
import SkuTable from '../components/sku-table'
export default {
  name: 'ecom-base-awsspu-detail',
  components: {
    EditForm,
    SkuTable,
  },
  data() {
    return {
      skuDisabled: false,
      formData: {},
    }
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    amzSpuCode() {
      return this.params.amzSpuCode
    },
    //禁用表单 + 保存按钮 控制 禁用表单时保存按钮不显示
    formDisabled() {
      return (
        this.pageType === 'detail' ||
        this.pageType === 'addSku' ||
        this.isChangeName
      )
    },
    isChangeName() {
      return this.pageType === 'changeName'
    },
    //增加SKU显示控制
    addSku() {
      return this.pageType === 'addSku'
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    reload() {
      this.getData()
      this.$refs.skuTable.getData()
    },
    getData() {
      if (!this.amzSpuCode) return
      this.$api
        .ecomAmzSpuDetailApi({
          amzSpuCode: this.amzSpuCode,
        })
        .then((res) => {
          this.formData = res.body
          this.skuDisabled = this.formData.amzSpuStatus === 'Y'
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
  margin: 15px 0;
}
.edit_form {
  padding: 15px 15px 5px 15px;
  border-radius: 5px;
  background-color: #fff;
}
.mt_10 {
  margin-top: 10px;
}
</style>
